import moment from "moment-timezone";
export const ISO8601_DATE_FORMAT = "YYYY-MM-DD";
export const getYear = date => moment(date).year();
export const formatIsoDate = (date, output = ISO8601_DATE_FORMAT) => moment(date).tz("Europe/London").format(output);
export const diffDays = (firstDate, secondDate, format = ISO8601_DATE_FORMAT) => {
  secondDate = secondDate || moment().format(ISO8601_DATE_FORMAT);
  return moment(firstDate, format).diff(moment(secondDate, format), "days");
};